import { makeSelector } from "../../../testing/index.js";
const TestingAttrs = {
  iconRight: "data-icon-right"
};
({
  iconRight: makeSelector("Icon displayed on the right", TestingAttrs.iconRight)
});
export {
  TestingAttrs
};
